module.exports = __webpack_public_path__ + "img/slc-2600-2x.c8ea7089.jpg";